import RegisteredAction from 'src/app/model/registered-action';
import { SubmitRequestRegisteredAction } from './helper-interfaces/submit-request-registered-action';

export class TaskSubmitHelper {
  private constructor() {}

  public static mapToSubmitRequestRegisteredAction(
    registeredAction: RegisteredAction
  ): SubmitRequestRegisteredAction {
    return registeredAction == null
      ? null
      : {
          id: registeredAction.id,
          user:
            registeredAction.user == null
              ? null
              : { id: registeredAction.user.id },
          date: registeredAction.date,
          type: registeredAction.type
        };
  }
}
